import { Component } from "@angular/core"
import { ViewController } from "ionic-angular"

@Component({
  selector: "use-terms-page",
  templateUrl: "use-terms.html",
})
export class UseTermsPage {

  constructor(
    private viewCtrl: ViewController
  ) {}

  onExit() {
    this.viewCtrl.dismiss()
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/use-terms.ts